<img src="./assets/logo-colored.png" class="logo" />

<div class="flex-it flex-col">
  <!--Email Field-->
  <mat-form-field appearance="outline" (keyup.enter)="login()">
    <mat-label>Email</mat-label>
    <input matInput placeholder="Email" type="email" [(ngModel)]="email" />
  </mat-form-field>

  <!--Password Field-->
  <mat-form-field appearance="outline" (keyup.enter)="login()">
    <mat-label>Password</mat-label>
    <input
      matInput
      placeholder="Password"
      type="password"
      [(ngModel)]="password"
    />
  </mat-form-field>

  <!--Login Button-->
  <app-shared-action-button
    class="login-button"
    [fullWidth]="true"
    [loading]="pending()"
    [disabled]="pending()"
    ariaLabel="Login"
    (pressed)="login()"
  >
    Login
  </app-shared-action-button>

  @if (credentialError()) {
    <p class="auth-dialog__error" role="alert">
      Unable to sign in. Please check your details and try again.
    </p>
  }

  <!--Register-->
  <!--TODO: Placeholders only! -->
  <div class="login-options flex-it flex-col flex-xcontent-center">
    <mat-checkbox [disabled]="true">Remember me</mat-checkbox>
    <div class="login-options">
      <button mat-button color="primary" [disabled]="true">
        Forgot Password?
      </button>
      <button mat-button color="primary" [disabled]="true">
        Register for an account
      </button>
    </div>
  </div>
</div>
